__turbopack_context__.v({
  "container": "styles-module-scss-module__7Vf62a__container",
});
